export default {
    'Remove': 'Remove',
    'Confirm': 'Confirm',
    'cancel': 'Cancel',
    'Save': 'Save',
    'View': 'View',
    'Name': 'Name',
    'Email': 'Email',
    'Upload_Image': 'Upload Image',
    'Profile_picture': 'Profile picture',
    'remove_modal_text': 'Are you sure you want to remove this image?',
    'field_validation_empty': 'Field is required.',
    'name_validation_empty': 'Enter a Name.',
    'email_validation_empty': 'Enter an Email.',
    'email_validation_valid': 'Enter a valid Email.',
    'Add_contact': 'Add contact',
    'error_update_profile': 'Error while updating profile'
};


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/i18n/en.js